__turbopack_context__.v({
  "className": "VmEVmG_className",
  "variable": "VmEVmG_variable",
});
